import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min'; // Import Bootstrap JavaScript

function ContactUs() {
  return (
    <div className="container-fluid">
        <style>
            {`
             @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
             body {
                font-family: 'Roboto';
              }
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
            `}
        </style>
          {/* Banner Image: Only visible when Home link is active */}
        <div className="home-banner">
          <img src="/Banner 3.png" alt="Footprint Banner" style={{ width: '100%', height: '30vh', objectFit: 'cover' }}/>
        </div>
    <section id="contact-us" className="container-fluid">
        <div className="container" sx={{textAlign: 'justify'}}> {/* Aligns text to the left */}
          <h2 style={{ color: '#009EDB', paddingTop: '1em', paddingBottom: '10px' }}>Office of Science</h2>
          <p>            
            <strong>UN Environment Programme</strong><br />
            United Nations Avenue, Gigiri<br />           
            P.O. Box 30552, 00100 <br />
            Nairobi, Kenya<br />           
            <strong>Email:</strong> <a href="mailto:unep-oos-sdgs@un.org">unep-oos-sdgs@un.org</a>
          </p>
      </div>
    </section>
    </div>
  );
}

export default ContactUs;
